import { getApiBaseUrl } from '../config/publicEnv';
import { ApiError, getJson } from './client';

// --- Types (app SessionController) ---

export type SessionIntrospection = {
  user_id: string;
  roles: string;
  login_provider: string;
  created_at: number;
  last_active_at: number;
};

// --- Functions ---

/**
 * `roles` 는 백엔드 세션 스냅샷의 롤 문자열 ("USER,ADMIN" 형태).
 * 구분자/공백/괄호 변형에 관대하게 파싱한다.
 */
export function parseSessionRoles(roles: string): string[] {
  return roles
    .split(/[,\s[\]"']+/)
    .map((role) => role.trim().toUpperCase())
    .filter(Boolean);
}

export function hasSessionRole(
  session: SessionIntrospection | null | undefined,
  role: string,
): boolean {
  if (!session) return false;
  return parseSessionRoles(session.roles).includes(role.toUpperCase());
}

export function getSession() {
  return getJson<SessionIntrospection>('/api/auth/session', {
    preserveAuthOnUnauthorized: true,
  });
}

/** DELETE /api/auth/session returns 204 with no envelope — plain fetch. */
export async function destroySession(): Promise<void> {
  let response: Response;
  try {
    response = await fetch(`${getApiBaseUrl()}/api/auth/session`, {
      credentials: 'include',
      method: 'DELETE',
    });
  } catch {
    throw new ApiError('네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.', 0);
  }
  if (!response.ok) {
    throw new ApiError('세션 종료에 실패했습니다.', response.status);
  }
}
